import { Component, Input } from '@angular/core';
import { TimelineItemComponent } from './timeline-item.component';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';

@Component({
    selector: 'app-timeline',
    template: `
    <!-- Mobile View -->
    <div class="tw-flex tw-flex-col tw-w-full">
      @for (item of items; track item; let i = $index) {
        <div
          class="x-tw-grow md:tw-hidden "
          >
          <div>
            <div class="icon">
              <div
              [ngClass]="{
                'inner-icon': true,
                'success-icon': item.status === 'Success',
                'error-icon': item.status === 'Error',
                'pending-icon': item.status === 'Pending',
                'unknown-icon': item.status === 'Unknown'
              }"
                >
                @if (item.status === 'Success') {
                  <mat-icon
                    class="done"
                    >done</mat-icon
                    >
                  } @else {
                    @if (item.status === 'Error') {
                      <mat-icon
                        class="exclamate"
                        >error_outline</mat-icon
                        >
                      } @else {
                        {{
                        i + 1 | number : '2.0-0'
                        }}
                      }
                    }
                  </div>
                </div>
              </div>
              <div
                class="label-container"
                [style.padding-top]="'10px'"
                [style.padding-right.px]="padding"
                [ngClass]="item.details ? 'popuptop' : ''"
                >
                <div class="description-container tw-w-full">
                  <div class="tw-w-full">
                    <span
                      class="uppercase-label clear"
                [ngClass]="
                  item.status === 'Success' ? 'uppercase-label-color' : ''
                "
                      >
                      {{ item.description1 | translation:translationRequest}}
                    </span>
                    <span
                      class="uppercase-label clear"
                [ngClass]="
                  item.status === 'Success' ? 'uppercase-label-color' : ''
                "
                      >{{ item.description2 | translation:translationRequest }}</span
                      >
                    </div>
                    @if (item.dateList !== undefined && item.dateList.length > 0) {
                      @for (dateitem of item.dateList; track dateitem; let j = $index) {
                        <span
                          class="uppercase-label clear"
                [ngClass]="
                  item.status === 'Success' ? 'uppercase-label-color' : ''
                "
                          >{{ dateitem.trackerLabel }}:
                          <span
                            class="small-label"
                  [ngClass]="
                    item.status === 'Success' ? 'small-label-color' : ''
                  "
                            >{{ dateitem.trackerDate | format:'date' }}</span
                            ></span
                            >
                          }
                        }
                        @if (
                          (item.dateList === undefined || item.dateList.length === 0) &&
                          item.date !== undefined &&
                          item.date !== null
                          ) {
                          <span
                            class="small-label clear"
                            [ngClass]="item.status === 'Success' ? 'small-label-color' : ''"
                            >{{ item.date |  format:'date' }}</span
                            >
                          }
                          @for (detail of item.details; track detail) {
                            <div class="clear">
                              <span class="short-side-line"></span>
                              <span
                [ngClass]="{
                  'detail-step-icon': true,
                  'detail-success-icon': detail.status === 'Success',
                  'detail-error-icon': detail.status === 'Error'
                }"
                                class="short-side-check"
                                >
                                @if (detail.status === 'Success') {
                                  <mat-icon>done</mat-icon>
                                }
                                @if (detail.status === 'Error') {
                                  <mat-icon>close</mat-icon>
                                }
                              </span>
                              <span class="app-pl2">{{ detail.description | translation:translationRequest}}</span>
                            </div>
                          }
                        </div>
                      </div>
                      <div
                        class="short-line"
          [style.border-left]="
            i === items.length - 1
              ? '0px solid transparent'
              : item.status === 'Success'
              ? '3px solid var(--sed-status-green-color)'
              : '2px solid #D2D8E1'
          "
                        [style.height]="'40px'"
                        [style.margin-left]="'15px'"
                      ></div>
                    </div>
                  }
                </div>
    
                <!-- Desktop View -->
                <div class="tw-flex tw-w-full tw-justify-center">
                  @for (item of items; track item; let i = $index) {
                    <div
                      class="x-tw-grow tw-hidden md:tw-block"
                      tabindex="0"
                      [style.padding-left.px]="i === 0 ? padding : ''"
                      >
                      <div
                        class="line"
          [style.border-bottom]="
            i === items.length - 1
              ? '0px solid transparent'
              : item.status === 'Success'
              ? '3px solid var(--sed-status-green-color)'
              : '2px solid #D2D8E1'
          "
                        >
                        <div class="icon">
                          <div
              [ngClass]="{
                'inner-icon': true,
                'success-icon': item.status === 'Success',
                'error-icon': item.status === 'Error',
                'pending-icon': item.status === 'Pending',
                'unknown-icon': item.status === 'Unknown'
              }"
                            >
                            @if (item.status === 'Success') {
                              <mat-icon
                                class="done"
                                [attr.aria-label]="'Step ' + (i + 1) + ' completed'"
                                [attr.aria-hidden]="false"
                                >done</mat-icon
                                >
                              }
                              @if (item.status === 'Error') {
                                <mat-icon
                                  class="exclamate"
                                  [attr.aria-label]="'Step ' + (i + 1) + ' past due'"
                                  >error_outline</mat-icon
                                  >
                                }
                                @if (item.status === 'Pending' || item.status === 'Unknown') {
                                  <span
                                    tabindex="-1"
                                    aria-hidden="false"
                [attr.aria-label]="
                  item.status === 'Pending'
                    ? 'Step ' + (i + 1) + 'Pending'
                    : 'Step ' + (i + 1)
                "
                                    >
                                    {{ i + 1 | number : '2.0-0' }}</span
                                    >
                                  }
                                </div>
                              </div>
                            </div>
                            <div
                              class="label-container"
                              [style.padding-right.px]="padding"
                              [ngClass]="item.details ? 'popuptop' : ''"
                              >
                              <div class="description-container">
                                <div
                                  class="uppercase-label clear"
              [ngClass]="
                item.status === 'Success' ? 'uppercase-label-color' : ''
              "
                                  >
                                  {{ item.description1 | translation:translationRequest }}
                                  <span [hidden]="!item.details">
                                    <app-overlay [origin]="detailOrigin" #detailOverlay>
                                      @if (detailOverlay.opened) {
                                        <app-panel [showTitle]="false">
                                          <div class="app-pt1 ">
                                            <div class="clear tw-w-full">
                                              <mat-icon
                                                class="detail-icon overlay-close"
                                                tabindex="0"
                                                (click)="detailOverlay.close()"
                                                >highlight_off</mat-icon
                                                >
                                              </div>
                                              @for (detail of item.details; track detail) {
                                                <div class="clear">
                                                  <span
                          [ngClass]="{
                            'detail-step-icon': true,
                            'detail-success-icon': detail.status === 'Success',
                            'detail-error-icon': detail.status === 'Error'
                          }"
                                                    >
                                                    @if (detail.status === 'Success') {
                                                      <mat-icon
                                                        >done</mat-icon
                                                        >
                                                      }
                                                      @if (detail.status === 'Error') {
                                                        <mat-icon
                                                          >close</mat-icon
                                                          >
                                                        }
                                                      </span>
                                                      <span class="app-pl2">{{ detail.description | translation:translationRequest}}</span>
                                                    </div>
                                                  }
                                                  <br />
                                                </div>
                                              </app-panel>
                                            }
                                          </app-overlay>
                                          <mat-icon
                                            [hidden]="!item.details"
                                            class="detail-icon"
                                            tabindex="0"
                                            (click)="detailOverlay.open()"
                                            cdkOverlayOrigin
                                            #detailOrigin="cdkOverlayOrigin"
                                            >add_circle_outline</mat-icon
                                            >
                                          </span>
                                        </div>
                                        <div
                                          class="uppercase-label clear"
              [ngClass]="
                item.status === 'Success' ? 'uppercase-label-color' : ''
              "
                                          >
                                          {{ item.description2 | translation:translationRequest }}
                                        </div>
                                        @if (item.dateList !== undefined && item.dateList.length > 0) {
                                          @for (dateitem of item.dateList; track dateitem; let j = $index) {
                                            <div
                                              class="uppercase-label clear"
                [ngClass]="
                  item.status === 'Success' ? 'uppercase-label-color' : ''
                "
                                              >
                                              {{ dateitem.trackerLabel }}:
                                              <span
                                                class="small-label"
                  [ngClass]="
                    item.status === 'Success' ? 'small-label-color' : ''
                  "
                                                >{{ dateitem.trackerDate | format:'date'}}</span
                                                >
                                              </div>
                                            }
                                          }
                                          @if (
                                            (item.dateList === undefined || item.dateList.length === 0) &&
                                            item.date !== undefined &&
                                            item.date !== null
                                            ) {
                                            <div class="small-label clear">
                                              {{ item.date | format:'date' }}
                                            </div>
                                          }
                                        </div>
                                        <!-- <div
            [ngClass]="{
              'uppercase-label': true,
              'pending-label':
                item.status !== 'Error' && item.status !== 'Unknown',
              'error-label': item.status === 'Error',
              'unknown-label': item.status === 'Unknown'
            }"
                                        >
                                        {{ item.label }}
                                      </div> -->
                                    </div>
                                  </div>
                                }
                              </div>
    `,
    styles: [
        `
      .inner-icon {
        height: 32px;
        width: 32px;
        padding: 5px;
        margin-top: 2px;
        margin-left: 2px;
        text-align: center;
        border-radius: 50%;
        display: inline-block;
        font-size: 16px;
        font-weight: bold;
      }

      .success-icon {
        -background-color: var(--sed-status-green-color);
        background-color: var(--sed-status-green-color);
      }

      .error-icon {
        color: var(--sed-warm-white-color);
        background-color: var(--sed-status-red-color);
        -background-color: #fff0f3;
      }

      .pending-icon {
        background-color: var(--sed-grey-60-color);
        -color: var(--sed-dynamic-black-color);
        color: var(--sed-dynamic-black-color);
      }

      .unknown-icon {
        background-color: #f1f4f7;
        color: #000;
      }

      .icon {
        float: left;
        font-size: 0;
        height: 36px;
        width: 36px;
        padding-bottom: 10px;
        margin-top: 3px;
        background-color: white;
      }

      .icon-mobile {
        font-size: 36px;
        height: 36px;
        width: 36px;
        padding-bottom: 10px;
        margin-top: 3px;
        background-color: white;
      }

      .done {
        float: left;
        font-size: 22px;
        height: 22px;
        width: 22px;
        -color: var(--sed-warm-white-color);
        color: var(--sed-warm-white-color);
      }
      .exclamate {
        float: left;
        font-size: 22px;
        height: 22px;
        width: 22px;
        -color: var(--sed-warm-white-color);
        color: var(--sed-warm-white-color);
      }

      .line {
        padding-bottom: 20px;
        min-width: 120px;
        width: 100%;
      }

      .short-line {
        padding-bottom: 20px;
        width: 75px;
      }

      .short-side-line {
        border-left: 3px solid var(--sed-status-green-color);
        display: inline-block;
        width: 1px;
        height: 20px;
        position: relative;
        left: -15px;
        margin-bottom: -6px;
      }

      .short-side-check {
        margin-left: 12px;
      }

      .line-mobile {
        height: 100%;
        margin-right: 17px;
      }

      .last-line {
        border-bottom: 3px solid transparent;
        padding-bottom: 20px;
      }

      .label-container {
        padding-left: 4px;
        padding-top: 20px;
        font-size: 13px;
        -padding-right: 40px;
      }

      .label-container-mobile {
        padding-left: 4px;
        font-size: 13px;
        padding-bottom: 20px;
        padding-top: 10px;
      }

      .description-container {
        align-items: center;
        font-size: 11px;
      }

      .description-flex {
        display: flex;
      }

      .uppercase-label {
        text-transform: uppercase;
        font-weight: bold;
      }
      .uppercase-label-color {
        color: var(--sed-black-80-color);
      }
      .small-label {
        text-transform: uppercase;
        font-weight: normal;
      }
      .small-label-color {
        color: var(--sed-black-80-color);
      }
      .pending-label {
        color: var(--color-sedgwick-blue);
      }

      .error-label {
        color: var(--sed-status-red-color);
      }

      .unknown-label {
        color: #c3c8ce;
      }

      .detail-icon {
        font-size: 18px;
        height: 18px;
        width: 18px;
        color: var(--color-input-grey);
        margin-left: 2px;
        cursor: pointer;
      }

      .detail-overlay {
      }

      .detail-step-icon {
        font-size: 14px;
        height: 14px;
        width: 14px;
        color: #c3c8ce;
        float: left;
      }

      .detail-success-icon {
        color: #507b20;
      }
      .detail-error-icon {
        color: var(--sed-status-red-color);
      }
      .overlay-close {
        float: right;
      }
      .popuptop {
        padding-top: 15px !important;
      }
    `,
    ],
    standalone: false
})
export class TimelineComponent {
  @Input()
  padding = 0;

  @Input()
    translationRequest: TranslationRequest;

  items: TimelineItemComponent[] = [];

  addItem(item: TimelineItemComponent) {
    this.items.push(item);
  }

  removeItem(item: TimelineItemComponent) {
    const index = this.items.indexOf(item);
    this.items.splice(index, 1);
  }
}
